import ProjectExecutionActivationPage from "../../shared/project-execution-activation/ProjectExecutionActivationPage";

const ManagementProjectExecutionActivationPage = () => (
  <ProjectExecutionActivationPage source="Management" />
);

export default ManagementProjectExecutionActivationPage;
